import { generateLocalsOptionList } from "utils/searchFilter";
import RangeFilter from "./RangeFilter";
import useSearchFilter from "hooks/useSearchFilter";
import { ReactComponent as RoomsFilterIcon } from "assets/icons/locals_filter.svg";

const RoomFilter = () => {
  const { roomMin, roomMax, setRoomMin, setRoomMax } = useSearchFilter();

  return (
    <RangeFilter
      id="rooms"
      placeholder="Locali"
      options={generateLocalsOptionList()}
      unit="locale"
      paramMin="roomMin"
      paramMax="roomMax"
      minValue={roomMin}
      maxValue={roomMax}
      setMinValue={setRoomMin}
      setMaxValue={setRoomMax}
      Icon={RoomsFilterIcon}
    />
  );
};

export default RoomFilter;
